// Common helper functions for the configurator

export function formatPrice(price: number): string {
  return price.toLocaleString();
}

export function getCurrentDate(): string {
  return new Date().toLocaleDateString('pl-PL');
}

export function getCurrentDateTime(): string {
  const now = new Date();
  const date = now.toLocaleDateString('pl-PL');
  const time = now.toLocaleTimeString('pl-PL', { hour: '2-digit', minute: '2-digit' });
  return `${date} ${time}`;
}

export async function copyToClipboard(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    alert('Zestawienie skopiowane do schowka!');
  } catch {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    alert('Zestawienie skopiowane do schowka!');
  }
}

export function openEmailClient(subject: string, body: string): void {
  const mailtoLink = `mailto:unico@unico-kominki.pl?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = mailtoLink;
}

// Debounce utility for performance optimization
export function debounce<T extends (...args: any[]) => void>(
  fn: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timer: ReturnType<typeof setTimeout> | null = null;
  return function (...args: Parameters<T>) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      try {
        fn(...args);
      } catch (e) {
        console.error(e);
      }
    }, wait);
  };
}
